import { ElementRef, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  DateInputModule,
  DatePickerModule,
  DateTimePickerModule,
  TimePickerModule
} from '@progress/kendo-angular-dateinputs';
import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NotificationModule, NotificationService, NOTIFICATION_CONTAINER } from '@progress/kendo-angular-notification';
import { PagerModule } from '@progress/kendo-angular-pager';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { UploadModule } from '@progress/kendo-angular-upload';

export function provideNotificationContainerToKendoNotification(): ElementRef {
  return { nativeElement: document.body } as ElementRef;
}

@NgModule({
  imports: [FormsModule, InputsModule],
  declarations: [],
  providers: [
    NotificationService,
    {
      provide: NOTIFICATION_CONTAINER,
      useFactory: provideNotificationContainerToKendoNotification
    }
  ],
  exports: [
    ButtonsModule,
    DatePickerModule,
    DateTimePickerModule,
    DateInputModule,
    DialogModule,
    WindowModule,
    DropDownsModule,
    GridModule,
    InputsModule,
    LabelModule,
    UploadModule,
    TooltipModule,
    LayoutModule,
    NotificationModule,
    TreeViewModule,
    DateTimePickerModule,
    TimePickerModule,
    PopupModule,
    EditorModule,
    PagerModule
  ]
})
export class RomeKendoModule {
  static forRoot(): ModuleWithProviders<RomeKendoModule> {
    return {
      ngModule: RomeKendoModule,
      providers: [NotificationService]
    };
  }
}
